import * as React from "react";
import {
  makeStyles,
  Button,
  Text,
  Card,
  Spinner,
} from "@fluentui/react-components";
import { PersonRegular } from "@fluentui/react-icons";
import { supabase } from "../../services/supabase";

const useStyles = makeStyles({
  page: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh",
    backgroundColor: "#f8fafc",
  },
  card: {
    padding: "48px 40px",
    borderRadius: "16px",
    boxShadow:
      "0 1px 3px rgba(0, 0, 0, 0.04), 0 8px 24px rgba(0, 0, 0, 0.06)",
    border: "1px solid #f1f5f9",
    maxWidth: "400px",
    width: "100%",
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "24px",
  },
  logo: {
    fontSize: "28px",
    fontWeight: "700",
    background: "linear-gradient(135deg, #4ECBA5 0%, #2d8b6b 100%)",
    backgroundClip: "text",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    letterSpacing: "-0.5px",
  },
  subtitle: {
    fontSize: "14px",
    color: "#64748b",
  },
  button: {
    width: "100%",
    height: "44px",
    fontSize: "14px",
    fontWeight: "600",
  },
  error: {
    color: "#ef4444",
    fontSize: "13px",
  },
});

export const LoginPage: React.FC = () => {
  const styles = useStyles();
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState<string | null>(null);

  const handleGoogleLogin = async () => {
    setLoading(true);
    setError(null);
    try {
      const { data, error: authError } = await supabase.auth.signInWithOAuth({
        provider: "google",
        options: {
          redirectTo: window.location.origin,
          skipBrowserRedirect: true,
        },
      });
      if (authError) {
        setError(authError.message);
        setLoading(false);
        return;
      }
      if (data?.url) {
        window.location.href = data.url;
      } else {
        setError("Failed to get login URL");
        setLoading(false);
      }
    } catch (e: unknown) {
      const msg = e instanceof Error ? e.message : "Login failed";
      setError(msg);
      setLoading(false);
    }
  };

  return (
    <div className={styles.page}>
      <Card className={styles.card}>
        <Text className={styles.logo}>Talkivo Admin</Text>
        <Text className={styles.subtitle}>Sign in to manage users</Text>

        {error && <Text className={styles.error}>{error}</Text>}

        <Button
          appearance="primary"
          icon={loading ? <Spinner size="tiny" /> : <PersonRegular />}
          className={styles.button}
          onClick={handleGoogleLogin}
          disabled={loading}
        >
          {loading ? "Signing in..." : "Sign in with Google"}
        </Button>
      </Card>
    </div>
  );
};
